import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { type AbstractModel, AbstractModelImpl } from '@/services/common/abstract-model';
import type { DescriptionState } from '../type/ai-search.type';


export const AISearchDescriptionModel = Symbol('AISearchDescriptionModel');

export interface AISearchDescriptionModel extends AbstractModel<DescriptionState>{}


@injectable()
export class AISearchDescriptionModelImpl extends AbstractModelImpl<DescriptionState> implements AISearchDescriptionModel {
    protected _modelData: DescriptionState = {
        desc: '',
        checkLawfulLoading: false,
    };
}